module.exports = __webpack_public_path__ + "static/media/white-back.42dbf33e.png";